import { render } from "./DssIcon.vue?vue&type=template&id=8e2e45d4&scoped=true&ts=true"
import script from "./DssIcon.vue?vue&type=script&lang=ts"
export * from "./DssIcon.vue?vue&type=script&lang=ts"

import "./DssIcon.vue?vue&type=style&index=0&id=8e2e45d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2e45d4"]])

export default __exports__